<template>
    <section class="overviewContainer">
        <button @click="gotToDashboard">
            <b-icon-pie-chart-fill></b-icon-pie-chart-fill>
            <span>Ver Dashboard Completo</span>
        </button>

        <section class="cardContainerOver">
            <div v-for="(card, cardIdx) in cards" :key="'cardI-' + cardIdx" class="cardsOverview">
                <span>{{ card.label }}</span>
                <span>{{ card.count }}</span>
            </div>
        </section>
    </section>
</template>

<script>
import axios from 'axios';
import { urlMainAPI } from '../../../global';
export default {
    name: "Overview",
    props: ["filters"],
    data() {
        return {
            loading: false,
            cards: [
                { code: "Total", label: 'Total', count: 0 },
                { code: "Aberta", label: 'Abertas', count: 0 },
                { code: "AnaliseAndamento", label: 'Em Análise', count: 0 },
                { code: "AnaliseAtraso", label: 'Análise em Atraso', count: 0 },
                { code: "AcaoAndamento", label: 'Em Ações', count: 0 },
                { code: "AcaoAtraso", label: 'Ações em Atraso', count: 0 },
                { code: "Andamento", label: 'Em Andamento', count: 0 },
                { code: "EficaciaPendente", label: 'Avaliação Pendente', count: 0 },
                { code: "Concluida", label: 'Concluída', count: 0 },
                { code: "Cancelada", label: 'Cancelada', count: 0 },
                { code: "Recusada", label: 'Recusada', count: 0 },
            ],
            defaultFilters: {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
            }
        }
    },
    watch:{
        async "filters"(){
            await this.getStatus();
        }
    },
    methods: {
        gotToDashboard() {
            this.$router.push({ name: "rtadashboard" });
        },

        async getStatus() {
            let filters = this.defaultFilters;
            
            if(this.filters != null) filters = this.filters;
            
            let url = `${urlMainAPI}/getrtastatus`;
            let queryMount = [];

            if (filters.processId != null && filters.processId != undefined) queryMount.push(`processId=${filters.processId}`);
            if (filters.workshiftId != null && filters.workshiftId != undefined) queryMount.push(`workshiftId=${filters.workshiftId}`);
            if (filters.startDate != null && filters.startDate != undefined && filters.startDate != "" && filters.startDate != "Data inválida") queryMount.push(`startDate=${filters.startDate}`);
            if (filters.endDate != null && filters.endDate != undefined && filters.endDate != "" && filters.endDate != "Data inválida") queryMount.push(`endDate=${filters.endDate}`);

            if (queryMount.length > 0) url += `?${queryMount.join("&")}`


            await axios.get(url).then(res => {
                // Se o total for 0, zera todos os cards
                if (res.data.TotalCount === 0) {
                    this.cards.forEach(item => {
                        item.count = 0;
                    });
                } else {
                    this.cards.forEach(item => {
                        if (item.code == "Total") {
                            item.count = res.data.TotalCount;
                        }
                        else if (item.code == "Andamento") {
                            item.count = res.data.DoingCount;
                        }
                        else if (res.data.StatusCount[item.code] !== undefined) {
                            item.count = res.data.StatusCount[item.code];
                        }
                        else {
                            // Se o status não existe no dicionário, zera
                            item.count = 0;
                        }
                    });
                }
            }).catch(err => {
                console.error(err)
            });
        }
    },
    async mounted() {
        await this.getStatus();
    }
}
</script>

<style scoped>
.overviewContainer {
    margin: 0.25rem 0 0 0 !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
}

.overviewContainer button {
    color: #fff;
    background-color: #008787;
    padding: 0.3rem;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.3rem;
    font-weight: 500;
    font-size: 0.9rem;
    white-space: nowrap;
    height: 100%;
}

.cardContainerOver {
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
}

.cardsOverview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 0.7rem;
    border: 1px solid #008787;
    color: #008787;
    border-radius: 0.2rem;
    padding: 0.1rem 0.2rem;
    font-weight: 500;
    width: 6.5rem !important;
}

.cardsOverview span {
    white-space: nowrap;
}

.cardsOverview span:last-child {
    font-weight: 800;
}
</style>